module.exports = __webpack_public_path__ + "471973c5829498cf07058637ddc0aada.MP3";